export default "__VITE_ASSET__lblT3VmE__"